// ============================================================
// POSTHOG A/B PRICE TESTING - BREZZA SUPER MIX
// METAFIELD-POWERED: Reads test prices from product metafields
// ============================================================

(function() {
    'use strict';

    const CONFIG = {
        productId: '9935999303995',
        productHandle: 'brezza-super-mix',
        variantId: '50170607993147',
        testName: 'product-price-test',
        discountCodes: {
            'control': null,
            'test-variant-1': 'BRZ7K2M9X',
            'test-variant-2': 'BRZ4P8N3Q'
        },
        // Prices will be loaded from metafields
        prices: null,
        originalPrice: null,
        compareAtPrice: null // For discount badge calculation
    };

    function log(message, data = null) {
        if (data) {
            console.log(`💰 [Price Test] ${message}`, data);
        } else {
            console.log(`💰 [Price Test] ${message}`);
        }
    }

    // ============================================================
    // LOAD PRICES FROM METAFIELDS OR DOM
    // ============================================================
    function loadPricesFromMetafields() {
        // First try: look for data-price-container
        let priceContainer = document.querySelector('[data-price-container]');
        
        // Fallback: find any price element on the page
        if (!priceContainer) {
            log('⚠️ [data-price-container] not found, searching for price elements...');
            priceContainer = document.querySelector('.price, [class*="price"]');
        }
        
        if (!priceContainer) {
            log('⚠️ No price elements found on page');
            return false;
        }

        log('✅ Found price element');

        // Try to get prices from data attributes
        let originalPriceCents = priceContainer.getAttribute('data-price-original');
        let compareAtPriceCents = priceContainer.getAttribute('data-compare-at');
        let priceTest2 = priceContainer.getAttribute('data-price-test-2');
        let priceTest3 = priceContainer.getAttribute('data-price-test-3');

        // Fallback: parse from actual price text on page if attributes don't exist
        if (!originalPriceCents || !priceTest2 || !priceTest3) {
            log('⚠️ Data attributes not found, using hardcoded metafield values');
            
            // Use the metafield values we know exist
            const originalPrice = 199.99;  // Current product price
            const compareAtPrice = 299.99; // Compare at price
            
            CONFIG.prices = {
                'control': originalPrice,
                'test-variant-1': 189.99, // From price_test_2 metafield
                'test-variant-2': 179.99  // From price_test_3 metafield
            };
            
            CONFIG.originalPrice = originalPrice;
            CONFIG.compareAtPrice = compareAtPrice;
            
            log('✅ Loaded prices from fallback values:', CONFIG.prices);
            log('✅ Compare at price: $' + compareAtPrice.toFixed(2));
            return true;
        }

        // Parse from data attributes
        const originalPrice = originalPriceCents ? parseFloat(originalPriceCents) / 100 : null;
        const compareAtPrice = compareAtPriceCents ? parseFloat(compareAtPriceCents) / 100 : originalPrice;

        if (!originalPrice) {
            log('⚠️ Original price not found');
            return false;
        }

        // Build prices object
        CONFIG.prices = {
            'control': originalPrice,
            'test-variant-1': priceTest2 ? parseFloat(priceTest2) : originalPrice,
            'test-variant-2': priceTest3 ? parseFloat(priceTest3) : originalPrice
        };

        CONFIG.originalPrice = originalPrice;
        CONFIG.compareAtPrice = compareAtPrice;

        log('✅ Loaded prices from data attributes:', CONFIG.prices);
        log('✅ Compare at price: $' + compareAtPrice.toFixed(2));
        return true;
    }

    function waitForPostHog(callback, maxAttempts = 50) {
        let attempts = 0;
        const checkPostHog = setInterval(() => {
            attempts++;
            if (typeof posthog !== 'undefined' && posthog.isFeatureEnabled) {
                clearInterval(checkPostHog);
                callback();
            } else if (attempts >= maxAttempts) {
                clearInterval(checkPostHog);
                console.warn('⚠️ [Price Test] PostHog not loaded');
            }
        }, 100);
    }

    const OVERRIDE_KEY = 'brezza_price_test_override';
    const savedOverride = localStorage.getItem(OVERRIDE_KEY);
    
    if (savedOverride && typeof posthog !== 'undefined' && posthog.featureFlags) {
        log(`🔄 Restoring saved override: ${savedOverride}`);
        posthog.featureFlags.override({[CONFIG.testName]: savedOverride});
    }

    function getCurrentVariant() {
        if (typeof posthog === 'undefined') return null;
        const savedOverride = localStorage.getItem(OVERRIDE_KEY);
        if (savedOverride) return savedOverride;
        return posthog.getFeatureFlag(CONFIG.testName);
    }

    // ============================================================
    // UPDATE ALL PRODUCT PAGE PRICES
    // ============================================================
    function updateProductPagePrice(variant) {
        const testPrice = CONFIG.prices[variant];
        
        if (!testPrice || testPrice === CONFIG.originalPrice) {
            log('No price update needed (control or same price)');
            return;
        }

        // Update ALL .price__regular elements on the page
        const priceElements = document.querySelectorAll('.price__regular');
        let updated = 0;

        priceElements.forEach(priceEl => {
            const currentText = priceEl.textContent.trim();
            const newPrice = `$${testPrice.toFixed(2)}`;
            
            // Only update if it contains a dollar amount
            if (currentText.includes('$') && /\d/.test(currentText)) {
                priceEl.textContent = newPrice;
                log(`✅ Updated "${currentText}" → "${newPrice}"`);
                updated++;
            }
        });

        if (updated > 0) {
            log(`✅ Updated ${updated} price element(s) to $${testPrice.toFixed(2)}`);
        } else {
            log('⚠️ No price elements found to update');
        }

        // Update discount badge with CORRECT savings
        const discountBadge = document.querySelector('.discount-percentage');
        if (discountBadge) {
            // Use compare_at_price (crossed-out price) for discount calculation
            const savings = CONFIG.compareAtPrice - testPrice;
            discountBadge.textContent = `($${savings.toFixed(0)} OFF)`;
            log(`✅ Updated discount badge to: ($${savings.toFixed(0)} OFF)`);
        }
    }

    // ============================================================
    // INJECT DISCOUNT INTO FORM
    // ============================================================
    function injectDiscountIntoForm(variant) {
        const discountCode = CONFIG.discountCodes[variant];
        
        if (!discountCode) {
            log('No discount code for this variant');
            return;
        }

        const discountField = document.getElementById(`price-test-discount-${CONFIG.productId}`);
        
        if (discountField) {
            discountField.value = discountCode;
            discountField.disabled = false;
            log(`✅ Injected discount code into form: ${discountCode}`);
        } else {
            log('⚠️ Discount field not found - did you add it to buy-buttons.liquid?');
        }

        // Store for cart drawer
        const testPrice = CONFIG.prices[variant];
        const testPriceCents = Math.round(testPrice * 100);
        
        sessionStorage.setItem('price_test_variant', variant);
        sessionStorage.setItem('price_test_price', testPrice);
        sessionStorage.setItem('price_test_discount_code', discountCode);
        
        const cartDrawerData = {
            variant: variant,
            testPrice: testPriceCents,
            discountCode: discountCode
        };
        
        sessionStorage.setItem('price_test_current', JSON.stringify(cartDrawerData));
        sessionStorage.setItem(`price_test_${CONFIG.variantId}`, JSON.stringify({
            testPrice: testPriceCents
        }));

        log('✅ Stored variant data for cart drawer');
    }

    // ============================================================
    // UPDATE STICKY BAR PRICES AND DISCOUNT BADGE
    // ============================================================
    function updateStickyBarPrice(variant) {
        const testPrice = CONFIG.prices[variant];

        if (!testPrice || testPrice === CONFIG.originalPrice) {
            log('No sticky bar price update needed (control or same price)');
            return;
        }

        // Find sticky bar
        const stickyBar = document.querySelector('.product-add-to-cart-sticky');

        if (!stickyBar) {
            log('Sticky bar not found');
            return;
        }

        // Update price in sticky bar
        const priceElements = stickyBar.querySelectorAll('.price__regular');
        let updated = 0;

        priceElements.forEach(priceEl => {
            const currentText = priceEl.textContent.trim();

            // Only update if it contains a dollar amount
            if (currentText.includes('$') && /\d/.test(currentText)) {
                const newPrice = `$${testPrice.toFixed(2)}`;
                priceEl.textContent = newPrice;
                log(`✅ Updated sticky price: "${currentText}" → "${newPrice}"`);
                updated++;
            }
        });

        // Update discount badge in sticky bar
        const discountBadge = stickyBar.querySelector('.discount-percentage');

        if (discountBadge) {
            const savings = CONFIG.compareAtPrice - testPrice;
            const newBadgeText = `($${savings.toFixed(0)} OFF)`;
            discountBadge.textContent = newBadgeText;
            log(`✅ Updated sticky discount badge to: ${newBadgeText}`);
        }

        if (updated > 0) {
            log(`✅ Sticky bar updated with ${updated} price element(s)`);
        }
    }

    // ============================================================
    // BACKUP CHECKOUT INTERCEPTION
    // ============================================================
    function interceptCheckoutLinks() {
        const discountCode = sessionStorage.getItem('price_test_discount_code');
        
        if (!discountCode) return;

        log('🎯 Setting up checkout link interception');

        document.addEventListener('click', function(e) {
            const target = e.target.closest('a[href*="/checkout"], button[name="checkout"]');
            if (!target) return;

            const href = target.href || '/checkout';
            
            if (href.includes('/checkout') || href.includes('checkouts')) {
                e.preventDefault();
                e.stopPropagation();
                
                const url = new URL(href, window.location.origin);
                url.searchParams.set('discount', discountCode);
                
                log(`🚀 Redirecting to checkout with discount`);
                window.location.href = url.toString();
                
                return false;
            }
        }, true);

        log('✅ Checkout interception active');
    }

    // ============================================================
    // MAIN INITIALIZATION
    // ============================================================
    function init() {
        if (!window.location.pathname.includes(CONFIG.productHandle)) {
            return;
        }

        log('🚀 Initializing price test for Brezza Super Mix');

        // FIRST: Load prices from metafields
        if (!loadPricesFromMetafields()) {
            log('❌ Failed to load prices from metafields');
            return;
        }

        const variant = getCurrentVariant();
        
        if (!variant) {
            console.warn('⚠️ No variant assigned');
            return;
        }

        log(`✅ Active variant: ${variant}`);
        log(`✅ Test price: $${CONFIG.prices[variant].toFixed(2)}`);
        log(`✅ Discount code: ${CONFIG.discountCodes[variant] || 'none'}`);

        // Update prices on page
        updateProductPagePrice(variant);

        // Inject discount into form
        injectDiscountIntoForm(variant);

        // Update sticky bar (with delay to ensure it's loaded)
        setTimeout(() => {
            updateStickyBarPrice(variant);
        }, 500);

        // Set up checkout interception
        interceptCheckoutLinks();

        log('✅ Price test initialization complete');
    }

    log('⏳ Waiting for PostHog...');
    waitForPostHog(init);

    if (typeof posthog !== 'undefined' && posthog.isFeatureEnabled) {
        setTimeout(init, 100);
    }

})();
